/* Owned consent-only bridge for the EXISTING Shopify banner. Unpublished.
 * No banner, cookies/localStorage, identifiers, contacts or Google calls.
 * Observations are not original choice times or Shopify-signed receipts.
 * Cart writes are NOT post-checkout revocation. Abort is best-effort only.
 */
(function () {
  'use strict';
  if (window.__tnsConsentBridge20261002) return;
  var installation = {};
  window.__tnsConsentBridge20261002 = installation;
  var queue = Promise.resolve();
  var previous = null;
  function explicit(value) {
    if (value === 'yes') return 'yes';
    if (value === 'no') return 'no';
    return 'unknown';
  }
  function allowed(api, method) {
    try {
      if (typeof api[method] !== 'function') return 'unknown';
      var result = api[method]();
      return result === true ? 'true' : result === false ? 'false' : 'unknown';
    } catch (_) { return 'unknown'; }
  }
  function snapshot() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.currentVisitorConsent !== 'function') return null;
    var choice;
    try { choice = api.currentVisitorConsent() || {}; } catch (_) { return null; }
    return {
      tns_consent_collector_version: 'tns-consent-observation-1',
      tns_consent_source: 'shopify_customer_privacy',
      tns_consent_api_available: 'true',

      tns_consent_marketing: explicit(choice.marketing),
      tns_consent_analytics: explicit(choice.analytics),
      tns_consent_preferences: explicit(choice.preferences),
      tns_consent_sale_of_data: explicit(choice.sale_of_data),
      tns_allowed_marketing: allowed(api, 'marketingAllowed'),
      tns_allowed_analytics: allowed(api, 'analyticsProcessingAllowed'),
      tns_allowed_preferences: allowed(api, 'preferencesProcessingAllowed'),
      tns_allowed_sale_of_data: allowed(api, 'saleOfDataAllowed')
    };
  }
  function writeCart(values) {
    return new Promise(function (resolve) {
      var settled = false;
      var abort = typeof window.AbortController === 'function' ? new window.AbortController() : null;
      var timer = window.setTimeout(function () {
        finish(false);
        if (abort) abort.abort();
      }, 4000);
      function finish(ok) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(ok);
      }
      try {
        var request = {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({attributes: values})
        };
        if (abort) request.signal = abort.signal;
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
        if (typeof root !== 'string' || !/^\/(?:[A-Za-z0-9_-]+\/)*$/.test(root)) root = '/';
        Promise.resolve(window.fetch(root + 'cart/update.js', request)).then(function (response) {
          finish(!!response && response.ok === true);
        }, function () { finish(false); });
      } catch (_) { finish(false); }
    });
  }
  function schedule(forceRefresh) {
    // Observe now, not after an older request: a short real withdrawal must
    // not disappear merely because the user regrants before the queue drains.
    var values = snapshot();
    if (!values) return;
    var stable = JSON.stringify(values);
    // The API gives current choices, never their original decision time.
    values.tns_consent_observed_at = new Date().toISOString();
    values.tns_consent_timestamp = values.tns_consent_observed_at;
    queue = queue.catch(function () {}).then(function () {
      if (stable === previous && forceRefresh !== true) return;
      return writeCart(values).then(function (ok) {
        previous = ok ? stable : null;
      });
    }).catch(function () {});
  }
  function refresh() { schedule(true); }
  function checkoutClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var control = target.closest('a[href], button[name="checkout"], input[name="checkout"]');
    if (!control) return;
    var href = control.getAttribute('href');
    if (control.getAttribute('name') === 'checkout' ||
        (typeof href === 'string' && /^\/(?:[A-Za-z0-9_-]+\/)*checkout(?:[?#]|$)/.test(href))) refresh();
  }
  function checkoutSubmit(event) {
    var form = event.target;
    if (!form || typeof form.getAttribute !== 'function') return;
    var action = form.getAttribute('action');
    if (typeof action !== 'string') return;
    var submitter = event.submitter;
    if (/^\/(?:[A-Za-z0-9_-]+\/)*checkout(?:[?#]|$)/.test(action) ||
        (/^\/(?:[A-Za-z0-9_-]+\/)*cart(?:[?#]|$)/.test(action) && submitter &&
         submitter.getAttribute('name') === 'checkout')) refresh();
  }
  var attempts = 0, started = false, active = true, loading = false, startupTimer;
  function startIfReady() {
    if (!active || started) return started;
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.currentVisitorConsent !== 'function') return false;
    started = true;
    window.clearTimeout(startupTimer);
    document.addEventListener('visitorConsentCollected', refresh);
    // Best effort only: never cancel, await, or replay a checkout action.
    document.addEventListener('click', checkoutClick, {capture: true, passive: true});
    document.addEventListener('submit', checkoutSubmit, {capture: true, passive: true});
    schedule();
    return true;
  }
  function boot() {
    if (!active || startIfReady()) return;
    if (++attempts > 40) {
      active = false;
      if (window.__tnsConsentBridge20261002 === installation) delete window.__tnsConsentBridge20261002;
      return;
    }
    // Finite retry also covers late Shopify injection and a feature callback
    // that never returns. An exhausted install leaves no poisoned singleton.
    startupTimer = window.setTimeout(boot, 250);
    if (!loading && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      loading = true;
      try {
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
          if (!error) startIfReady();
        });
      } catch (_) { /* finite polling remains the fallback */ }
    }
  }
  boot();
}());
